
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import BaseStep, { BaseStepProperties, BASE_STEP_PROPS } from './BaseStep.vue';
  import { computed, defineComponent, ref } from 'vue';

  export default defineComponent<BaseStepProperties>({
    components: {
      Button,
      BaseStep,
    },
    props: BASE_STEP_PROPS,

    setup() {
      const store = useIntegrationDetailsStore();
      const loading = ref(false);
      const instance = computed(() => store.instance);

      const submit = () => {
        loading.value = true;

        store.saveAndDeploy().then(() => {
          loading.value = false;
          store.closeModal();
        });
      };

      return {
        instance,
        submit,
        loading,
      };
    },
  });
